import {englishMessages} from "admin-on-rest";
import * as customMessages from "./i18n/";

export const messages = {
  sv: customMessages.sv,
  en: {...englishMessages, ...customMessages.en}
};


// WEBPACK FOOTER //
// ./src/AppMessages.js